<script lang="ts" setup>
import { ParagraphShopStartpageInfo } from '~/api/graphql/generated'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
  entity: ParagraphShopStartpageInfo
}>()
const items =
  props.entity.fieldLinks?.map((item, index) => {
    return {
      id: index,
      link: {
        text: item?.title || '',
        url: item?.url?.path || '',
      },
    }
  }) || []
</script>

<template>
  <Section name="search">
    <div class="search-content t-10 t-o-1 tl-7 tl-o-0 ds-o-1">
      <h2 class="f-18">{{ t('shop.startpage.search.title') }}</h2>
      <ShopSearch class="search-box" />
    </div>
  </Section>
  <SectionIntrotext v-if="entity.fieldText?.value" :text="entity.fieldText?.value" />
  <Section name="categories">
    <LinkList class="subcategories t-10 t-o-1 tl-7 tl-o-0 ds-o-1" :items="items" />
  </Section>
</template>
<style scoped lang="scss">
.subcategories {
  display: grid;
  gap: 0 var(--gap);
  @include breakpoint(ts) {
    grid-template-columns: 1fr 1fr;
  }
  .link {
    color: var(--c-primary);
    font-weight: 400;
  }
}
.search-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .search-box {
    width: 100%;
  }
}
</style>
